/* Clearance markdown: keep You save $X aligned if a variantChange bubbles. */
(function () {
  if (!window.jQuery) return;
  jQuery(document).on('variantChange', function (evt) {
    var variant = evt.variant;
    if (!variant) return;
    var $save = jQuery('[data-isf-clearance-save]');
    if (!$save.length) return;
    if (variant.compare_at_price > variant.price && window.theme && theme.Currency) {
      $save
        .text(
          'You save ' +
            theme.Currency.formatMoney(
              variant.compare_at_price - variant.price,
              theme.moneyFormat
            )
        )
        .removeClass('hide');
    } else {
      $save.addClass('hide');
    }
  });
})();
